/* 孫吳傳・第 11 章：柴桑（208 年）
 * 孫權在柴桑議事。中間是議事的大殿（圍牆圍起來，南面開門），殿外東側是廊下；西邊是城門（周瑜從鄱陽趕回），東北是館驛（諸葛亮來使）。 */
export const HALL = { x: 3000, y: 2000, hw: 700, hh: 420 };
const T = 36, N = HALL.y - HALL.hh, S = HALL.y + HALL.hh, Wx = HALL.x - HALL.hw, E = HALL.x + HALL.hw;
export const SEAT = [HALL.x, HALL.y - 220], DOOR = [HALL.x, S], EAVES = [E + 260, HALL.y + 260], GATE = [700, 2500], INN = [5000, 1300];
export default {
  id: 'chaisang', name: '柴桑', W: 6000, H: 4400, seed: 2081,
  bases: [[HALL.x, HALL.y + 700], [5600, 3800]],
  walls: [[HALL.x, N, HALL.hw + T, T], [Wx, HALL.y, T, HALL.hh], [E, HALL.y, T, HALL.hh], [Wx + 280, S, 280, T], [E - 280, S, 280, T]],
  roads: [
    { pts: [GATE, [1800, 2700], [HALL.x, S + 300], [4200, 2600], [INN[0], INN[1] + 300]], w: 150 },
    { pts: [[HALL.x, S + 300], DOOR, [HALL.x, HALL.y]], w: 120 },
  ],
  rocks: [[1200, 1100, 300, 160], [4900, 3500, 300, 160]],
  woods: 0.25,
  sight: 1,
  clearings: [[HALL.x, HALL.y, 900], [GATE[0], GATE[1], 300], [INN[0], INN[1], 380]],
  villages: [{ x: 1700, y: 3300, n: 8, r: 520 }, { x: 4300, y: 3300, n: 6, r: 420 }, { x: INN[0] + 200, y: INN[1] - 100, n: 3, r: 260 }],
  fields: [[1500, 1500, 500, 260]],
};
